import { useReactiveVar } from '@apollo/client';

import { useCareerJourneyBoardQuery } from 'core/graphql';
import { authState } from 'core/state';
import { isCareerViewer } from 'core/hooks/CareerCenter/isCareerViewer';

import { ICareerJourney, transformCareerJourney } from './transform';

interface IUseCareerJourney {
  journey: ICareerJourney | null;
  loading: boolean;
  error: string;
  refetch: () => void;
}

/**
 * Дорожная карта — ОДИН запрос на весь раздел (ТЗ 0069).
 *
 * 🔴 Запрос смонтирован в `CareerLayout`, то есть присутствует на КАЖДОМ
 * экране `/career/*`. Это несущее свойство, а не оптимизация наоборот:
 * `refetchQueries: ['CareerJourneyBoard']` сопоставляется с именем операции и
 * молча ничего не делает, если запрос в этот момент не смонтирован. Свести
 * его к одному `/career` — значит сломать обновление маршрута после
 * завершения урока и после сохранения профиля, и никакой гейт этого не увидит.
 *
 * `cache-and-network`, как `useMyCareerCenter`: студента могли записать в
 * центр в середине сессии, и раздел обязан открыться без перезагрузки.
 */
export const useCareerJourney = (): IUseCareerJourney => {
  const { active_role, isDemoUser } = useReactiveVar(authState);
  const skip = !isCareerViewer(active_role) || Boolean(isDemoUser);

  const { data, loading, error, refetch } = useCareerJourneyBoardQuery({
    fetchPolicy: 'cache-and-network',
    skip,
  });

  return {
    journey: skip ? null : transformCareerJourney(data),
    loading,
    error: error?.message || '',
    refetch,
  };
};
